/**
 * Verifies if an application can use DOM.
 */
export function canUseDOM() {
    return (typeof window !== 'undefined' &&
        !!(window.document &&
            // eslint-disable-next-line deprecation/deprecation
            window.document.createElement));
}
//# sourceMappingURL=canUseDOM.js.map